import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000
});

export const productApi = {
  getList() {
    return api.get('/products');
  },
  getDetail(id) {
    return api.get(`/products/${id}`);
  },
  create(data) {
    return api.post('/products', data);
  },
  update(id, data) {
    return api.put(`/products/${id}`, data);
  },
  updateStatus(id, status) {
    return api.patch(`/products/${id}/status`, { status });
  },
  delete(id) {
    return api.delete(`/products/${id}`);
  }
};

export const uploadApi = {
  uploadImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/upload/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export default api;
